var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.8999 14.168C2.8999 13.7261 3.25807 13.368 3.6999 13.368H13.2999C13.7417 13.368 14.0999 13.7261 14.0999 14.168C14.0999 14.6098 13.7417 14.968 13.2999 14.968H3.6999C3.25807 14.968 2.8999 14.6098 2.8999 14.168ZM5.53422 8.00228C5.84664 7.68986 6.35317 7.68986 6.66559 8.00228L7.6999 9.0366L7.6999 2.96797C7.6999 2.52614 8.05807 2.16797 8.4999 2.16797C8.94173 2.16797 9.2999 2.52614 9.2999 2.96797L9.2999 9.0366L10.3342 8.00228C10.6466 7.68986 11.1532 7.68986 11.4656 8.00228C11.778 8.3147 11.778 8.82123 11.4656 9.13365L9.06559 11.5337C8.91556 11.6837 8.71208 11.768 8.4999 11.768C8.28773 11.768 8.08425 11.6837 7.93422 11.5337L5.53422 9.13365C5.2218 8.82123 5.2218 8.3147 5.53422 8.00228Z",
    fill: "#4B5563"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.c64ea2d5.svg";
export { ForwardRef as ReactComponent };